export const iconViewBoxes = {
  arrowRight: '0 0 33 33',
  arrowLeft: '0 0 19 18',
  iconGlobe: '0 0 24 24',
  iconChevronBottom: '0 0 18 18',
  iconArrowRightBottom: '0 0 23 23',
  iconArrowRightBottomGradient: '0 0 23 23',
  play: '0 0 24 31',
  close: '0 0 13 13',
  search: '0 0 32 32',
  minus: '0 0 17 2',
  plus: '0 0 17 18',
  funnel: '0 0 18 18',
};
